(() => {
  const input = document.getElementById('Search-In-Template');
  const search = input?.closest('predictive-search');
  if (!search || search.dataset.nciKeyboardReady) return;
  search.dataset.nciKeyboardReady = 'true';
  let active = null;
  const clear = () => {
    search.querySelectorAll('[role="option"][aria-selected="true"]').forEach(option => option.setAttribute('aria-selected', 'false'));
    input.removeAttribute('aria-activedescendant');
    active = null;
  };
  const close = () => {
    clear();
    search.removeAttribute('open');
    input.setAttribute('aria-expanded', 'false');
  };
  input.addEventListener('input', close);
  search.addEventListener('focusout', event => {
    if (!search.contains(event.relatedTarget)) close();
  });
  input.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
      return;
    }
    if (event.key === 'Enter' && active && search.hasAttribute('open')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const target = active.matches('a, button') ? active : active.querySelector('a, button');
      target?.click();
      return;
    }
    if (!['ArrowDown', 'ArrowUp'].includes(event.key) || !input.value.trim()) return;
    const candidates = [...search.querySelectorAll('[role="option"]')];
    if (!candidates.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    search.setAttribute('open', '');
    input.setAttribute('aria-expanded', 'true');
    const options = candidates.filter(option => option.getClientRects().length && getComputedStyle(option).visibility !== 'hidden');
    if (!options.length) {
      close();
      return;
    }
    options.forEach((option, index) => {
      if (!option.id) option.id = `nci-search-option-${index}`;
    });
    const previous = options.indexOf(active);
    const next = previous < 0 ? (event.key === 'ArrowDown' ? 0 : options.length - 1) : (previous + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
    clear();
    active = options[next];
    active.setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', active.id);
    active.scrollIntoView({ block: 'nearest' });
  }, true);
  input.addEventListener('keyup', event => {
    if (['ArrowDown', 'ArrowUp', 'Escape'].includes(event.key) || (event.key === 'Enter' && active)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  const results = search.querySelector('[data-predictive-search]');
  if (results) new MutationObserver(() => {
    if (active && !results.contains(active)) close();
  }).observe(results, { childList: true, subtree: true });
})();
